const ALLOWED_AUTH_REDIRECTS = new Set(["/", "/my/product-digital"]);

export function safeAuthRedirect(value, fallback = "/") {
  return typeof value === "string" && ALLOWED_AUTH_REDIRECTS.has(value)
    ? value
    : fallback;
}
